export const maxUploadSizeInMB = parseFloat(process.env.REACT_APP_MAX_UPLOAD_SIZE_MEGABYTES || '20');

export const validateUploadSize = file => {
  const numberOfBytesInKibiByte = 1024;
  const maxUploadInBytes = maxUploadSizeInMB * numberOfBytesInKibiByte * numberOfBytesInKibiByte;
  return file.size <= maxUploadInBytes;
};
